'use strict';

var after = require('./siblings').after;

module.exports = first;

/* Get the first child in `parent`. */
function first(parent, includeWhiteSpace) {
  return after(parent, -1, includeWhiteSpace);
}



//////////////////
// WEBPACK FOOTER
// ./~/hast-util-to-html/lib/omission/util/first.js
// module id = 181
// module chunks = 96961042003272 139266963665775